export default __webpack_public_path__ + "static/media/b14.2957087e.jpg";